import { languages, findSupportedLanguageTag } from '@logto/language-kit';
import { z } from 'zod';
import ar from './locales/ar/index.js';
import de from './locales/de/index.js';
import en from './locales/en/index.js';
import es from './locales/es/index.js';
import faIR from './locales/fa-ir/index.js';
import fr from './locales/fr/index.js';
import it from './locales/it/index.js';
import ja from './locales/ja/index.js';
import ko from './locales/ko/index.js';
import plPL from './locales/pl-pl/index.js';
import ptBR from './locales/pt-br/index.js';
import ptPT from './locales/pt-pt/index.js';
import ru from './locales/ru/index.js';
import th from './locales/th/index.js';
import trTR from './locales/tr-tr/index.js';
import zhCN from './locales/zh-cn/index.js';
import zhHK from './locales/zh-hk/index.js';
import zhTW from './locales/zh-tw/index.js';
import viVN from './locales/vi-VN/index.js';
export const builtInLanguages = [
    'ar',
    'de',
    'en',
    'es',
    'fa-IR',
    'fr',
    'it',
    'ja',
    'ko',
    'pl-PL',
    'pt-BR',
    'pt-PT',
    'ru',
    'th',
    'tr-TR',
    'zh-CN',
    'zh-HK',
    'zh-TW',
    'vi-VN',
];
export const builtInLanguageOptions = builtInLanguages.map((languageTag) => ({
    value: languageTag,
    title: languages[languageTag],
}));
export const builtInLanguageTagGuard = z.enum(builtInLanguages);
export const getDefaultLanguageTag = (language) => builtInLanguageTagGuard.parse(findSupportedLanguageTag(language ? [language] : [], builtInLanguages));
export const isBuiltInLanguageTag = (language) => builtInLanguageTagGuard.safeParse(language).success;
const resource = {
    ar,
    de,
    en,
    es,
    'fa-IR': faIR,
    fr,
    it,
    ja,
    ko,
    'pl-PL': plPL,
    'pt-BR': ptBR,
    'pt-PT': ptPT,
    ru,
    th,
    'tr-TR': trTR,
    'zh-CN': zhCN,
    'zh-HK': zhHK,
    'zh-TW': zhTW,
    'vi-VN': viVN,
};
export default resource;
